import { type Query, useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";

import { ME_QUERY_KEY } from "./session-context";

/**
 * Privacy mode turned on or off, here or in another tab (ADRs 0144, 0145):
 * every screen loads again, from the demo copy or the real data, so nothing
 * shown before stays. The signed-in user is Axon's, and stays.
 */
export function usePrivacyReload(on: boolean): void {
  const queryClient = useQueryClient();
  const previous = useRef(on);

  useEffect(() => {
    if (previous.current === on) {
      return;
    }
    previous.current = on;
    const shown = { predicate: (query: Query) => query.queryKey[0] !== ME_QUERY_KEY[0] };
    void queryClient.cancelQueries(shown).then(() => queryClient.resetQueries(shown));
  }, [on, queryClient]);
}
